import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, CodeBlock, BlockType, ValidationMessage,
    ValidationMessageType, SettingState, TibboDataType,
} from '@appblocks/codegeneration/types';

export default class AzureCommand extends BaseFeature {
    constructor() {
        super();
        this.name = 'AzureCommand';
        this.id = 'azure_command';
        this.singleInstance = false;
        this.settings = this.settings.concat([
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.STRING,
                required: true,
                default: 'Command_Name',
            },
            {
                id: 'COMMAND_ID',
                name: 'ID',
                settingType: SettingType.STRING,
                required: true,
                default: 'Command_ID',
            },
        ]);
    }

    getDependencies() {
        const dependencies = [
            'azure',
        ];
        return dependencies;
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];
        const name = this.getSettingValue('NAME');
        return blocks;
    }
}
